import { EventCatalogFromKeys, EventType } from "../../../types";

export const ImpactEventKeys = {
  ADMIN_IMPACT_PAGE_VIEW: "admin-impact-page-view",
  ADMIN_IMPACT_PAGE_VIEW_ORGANIZATION_REQUIRED:
    "admin-impact-page-view-organization-required",
  ADMIN_IMPACT_TAB_CHANGE: "admin-impact-tab-change",
  IMPACT_CLIENT_AREA_CHART_INTERACTION: "impact-client-area-chart-interaction",
  IMPACT_CLIENT_CASEWORKER_PRODUCTIVITY_CHART_INTERACTION:
    "impact-client-caseworker-productivity-chart-interaction",
  IMPACT_CLIENT_COMMUNITY_CHART_INTERACTION:
    "impact-client-community-chart-interaction",
  IMPACT_CLIENT_EXPORT: "impact-client-export",
  IMPACT_CLIENT_PROGRAM_METRICS_CHART_INTERACTION:
    "impact-client-program-metrics-chart-interaction",
  IMPACT_CLIENT_TIME_PERIOD_CHANGE: "impact-client-time-period-change",
  IMPACT_CLIENT_YEAR_CHANGE: "impact-client-year-change",
} as const;

export const ImpactEventCatalog: EventCatalogFromKeys<typeof ImpactEventKeys> =
  {
    [ImpactEventKeys.ADMIN_IMPACT_PAGE_VIEW]: {
      description: "Admin viewed the impact page",
      eventType: EventType.PAGE_VIEW,
      id: ImpactEventKeys.ADMIN_IMPACT_PAGE_VIEW,
    },
    [ImpactEventKeys.ADMIN_IMPACT_PAGE_VIEW_ORGANIZATION_REQUIRED]: {
      description: "Admin viewed the impact page but organization is required",
      eventType: EventType.PAGE_VIEW,
      id: ImpactEventKeys.ADMIN_IMPACT_PAGE_VIEW_ORGANIZATION_REQUIRED,
    },
    [ImpactEventKeys.ADMIN_IMPACT_TAB_CHANGE]: {
      description: "Admin changed tab in impact report tabs",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.ADMIN_IMPACT_TAB_CHANGE,
    },
    [ImpactEventKeys.IMPACT_CLIENT_AREA_CHART_INTERACTION]: {
      description:
        "User interacted with the area impact chart in ImpactClient (community report)",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_AREA_CHART_INTERACTION,
    },
    [ImpactEventKeys.IMPACT_CLIENT_CASEWORKER_PRODUCTIVITY_CHART_INTERACTION]: {
      description:
        "User interacted with the caseworker productivity chart in ImpactClient (program report)",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_CASEWORKER_PRODUCTIVITY_CHART_INTERACTION,
    },
    [ImpactEventKeys.IMPACT_CLIENT_COMMUNITY_CHART_INTERACTION]: {
      description:
        "User interacted with the quarterly impact chart in ImpactClient (community report)",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_COMMUNITY_CHART_INTERACTION,
    },
    [ImpactEventKeys.IMPACT_CLIENT_EXPORT]: {
      description: "User exported data in ImpactClient",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_EXPORT,
    },
    [ImpactEventKeys.IMPACT_CLIENT_PROGRAM_METRICS_CHART_INTERACTION]: {
      description:
        "User interacted with the program metrics chart in ImpactClient (program report)",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_PROGRAM_METRICS_CHART_INTERACTION,
    },
    [ImpactEventKeys.IMPACT_CLIENT_TIME_PERIOD_CHANGE]: {
      description: "User changed the time period in ImpactClient",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_TIME_PERIOD_CHANGE,
    },
    [ImpactEventKeys.IMPACT_CLIENT_YEAR_CHANGE]: {
      description: "User changed the year in ImpactClient",
      eventType: EventType.INTERACTION,
      id: ImpactEventKeys.IMPACT_CLIENT_YEAR_CHANGE,
    },
  };
